export default (field, schema, values, asc = true) => {
  const isNumber = schema[field].type === 'number';
  const isObject = schema[field].type === 'object';

  return values.sort((a, b) => {
    const aValue = isObject ? a[field][schema[field].field] : a[field];
    const bValue = isObject ? b[field][schema[field].field] : b[field];

    const aField = isNumber ? a[field] : aValue.trim().toLowerCase();
    const bField = isNumber ? b[field] : bValue.trim().toLowerCase();
    const operator = asc ? 1 : -1;
    let order = 0;

    if (aField > bField) order = 1;
    else if (bField > aField) order = -1;

    return operator * order;
  });
};
